import HttpService from '../../services/http.service';
import { EEndpoint } from '../../config/endpoint.config';
import { IUser } from '../../domain/user.interface';
import axios from 'axios';
import history from '../../store/history/history';
import { ERoutes } from '../../assets/constants/routes';

export const CURRENT_USER_LOADED = 'CURRENT_USER_LOADED';
export const TOKEN_OBTAINED = 'TOKEN_OBTAINED';

const httpService = new HttpService();

export const loadCurrentUser = (body: any) => {
  return (dispatch: any) => {
    dispatch({
      type: CURRENT_USER_LOADED,
      payload: body,
    });
  };
};

export const getCurrentUser = () => {
  return (dispatch: any) => {
    httpService.get(EEndpoint.GET_CURRENT_USER).then((res: any) => {
      dispatch(loadCurrentUser(res));
    });
  };
};

export const editCurrentUser = (body: IUser, images: any) => {
  return (dispatch: any) => {
    httpService.put(EEndpoint.GET_CURRENT_USER, body).then((res: any) => {
      if (images.hasOwnProperty('user_photo')) {
        httpService.post(
          EEndpoint.USER_MAIN_PHOTO_UPLOAD,
          images['user_photo'],
          { params: { userId: res.id } },
        );
      }
      dispatch(loadCurrentUser(res));
    });
  };
};

export const loadToken = (body: any) => {
  return (dispatch: any) => {
    dispatch({
      type: TOKEN_OBTAINED,
      payload: body,
    });
  };
};

export const verifyEmail = async (userId: string) => {
  let data: any;
  await axios({
    method: 'post',
    baseURL: process.env.REACT_APP_API_URL,
    url: EEndpoint.EMAIL_VERIFICATION,
    data: { userId: userId },
  })
    .then((res: any) => (data = res))
    .catch((error: any) => (data = error.response));
  return data;
};

export const acceptPolicy = (body: any) => {
  return async (dispatch: any) => {
    await httpService.patch(EEndpoint.POLICY, body);
    dispatch(getCurrentUser());
    history.push(`${ERoutes.ONBOARDING}${ERoutes.HOME}`);
  };
};
